var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgSun = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    viewBox: "0 0 3 3",
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.04658847,0,0,0.04658847,0.01733877,0.02122463)",
    id: "Sun"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "m 31.97461,15.00244 a 17.00317,17.00317 0 1 0 17,17.00342 17.021,17.021 0 0 0 -17,-17.00342 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "m 59.002,29.00537 h -3.99663 a 3.0005,3.0005 0 0 0 0,6.001 H 59.002 a 3.0005,3.0005 0 0 0 0,-6.001 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "M 31.97461,51.99854 A 3.00307,3.00307 0 0 0 28.97607,54.999 v 4.00049 a 2.99829,2.99829 0 1 0 5.99658,0 V 54.999 a 3.00266,3.00266 0 0 0 -2.99804,-3.00046 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M 11.99316,32.00586 A 3.00307,3.00307 0 0 0 8.99462,29.00537 H 4.99854 a 3.0005,3.0005 0 0 0 0,6.001 h 3.99609 a 3.00307,3.00307 0 0 0 2.99853,-3.00051 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "M 31.97461,12.00146 A 3.00307,3.00307 0 0 0 34.97314,9.001 V 5.00049 a 2.99829,2.99829 0 1 0 -5.99658,0 V 9.001 a 3.00266,3.00266 0 0 0 2.99805,3.00046 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "m 50.36182,17.85919 2.82874,-2.82874 a 2.99828,2.99828 0 1 0 -4.24017,-4.24023 l -2.8288,2.8288 a 2.99828,2.99828 0 1 0 4.24023,4.24017 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "m 50.36145,46.15283 a 2.9983,2.9983 0 1 0 -4.24023,4.24023 L 48.95,53.2218 a 2.9983,2.9983 0 1 0 4.24023,-4.24023 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "m 13.5874,46.15247 -2.82874,2.8288 a 2.99826,2.99826 0 1 0 4.24017,4.24017 l 2.8288,-2.82874 A 2.9983,2.9983 0 1 0 13.5874,46.15247 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    d: "M 13.58777,17.85889 A 2.9983,2.9983 0 1 0 17.828,13.61865 l -2.8288,-2.8288 a 2.9983,2.9983 0 1 0 -4.2402,4.24024 z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSun, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sun.5955555f.svg";
export { ForwardRef as ReactComponent };